import styled from "styled-components";

import { QuietButton } from "../../../../shared/components/buttons/QuietButton.styled";
import StyledPassportPreview from "../components/passport-preview/styles/StyledPassportPreview.styled";
import AutomatedTools from "./AutomatedTools.styled";
import Card from "./Card.styled";

const StyledPassportPage = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;

  ${AutomatedTools} {
    margin: 16px 0 24px 0;
  }

  .manual-info {
    margin-bottom: 24px;
    text-align: center;
  }

  ${QuietButton} {
    width: 100%;
  }

  ${Card} {
    border: 1px solid ${({ theme }) => theme.colors.base3};
  }

  @media all and (max-width: ${({ theme }) => theme.mobileBreakingPoint}) {
    display: block;
    ${StyledPassportPreview} {
      display: none;
    }
  }
`;

export default StyledPassportPage;
